import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./base/HeaderComponent";
import Footer from "./base/FooterComponent";
import './RegistrationSuccess.module.css'

const RegistrationSuccess = () => {
    const navigate = useNavigate();

    const goToLogin = () => {
        navigate("/login");
    };

    return (
        <div>
            <Header />
            <div className="container text-center py-5">
                <div className="alert alert-success p-5 shadow-lg rounded" style={{'color': 'white', 'background': 'none'}}>
                    <h1 className="display-4">
                        ✅ Registrazione completata!
                    </h1>
                    <p className="lead mt-3">
                        Il tuo account è stato creato con successo. Puoi ora accedere alla piattaforma.
                    </p>
                    <button className="btn btn-primary mt-4" onClick={goToLogin}>
                        Vai al Login
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default RegistrationSuccess;
